import script from "./UserSubscriptionOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSubscriptionOverview.vue?vue&type=script&setup=true&lang=js"

import "./UserSubscriptionOverview.vue?vue&type=style&index=0&id=2b950eaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b950eaa"]])

export default __exports__